export interface IOrderItemSubStatusInput {
    reasons: string[];
}
